import { FleekError } from './FleekError';

type PathIsNotADirectoryErrorOptions = {
  path: string;
};

export class PathIsNotADirectoryError extends FleekError<PathIsNotADirectoryErrorOptions> {
  public name = 'PathIsNotADirectoryError';

  toString = () => {
    return `Given path ${this.data.path} is not a directory.`;
  };
}
